import attendance from '@/api/attendance-setting'

export const state = {
  resource: {}
}

export const getters = {}

export const mutations = {
  RECEIVE_RESOURCES(state, data) {
    state.resource = data
  }
}

export const actions = {
  fetch(context) {
    return attendance.get().then(response => {
      context.commit('RECEIVE_RESOURCES', response.data)
      return Promise.resolve(response.data)
    })
  },

  store(context, data) {
    return attendance.store(data)
  },

  destroy(context, id) {
    return attendance.destroy(id)
  }
}
